import { cn } from '../../lib/utils';

interface AspectRatioImageProps {
  src: string;
  alt: string;
  className?: string;
  containerClassName?: string;
  aspectRatio?: 'square' | 'video' | 'auto';
  size?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
}

const sizeClasses = {
  sm: 'h-16 w-16',
  md: 'h-24 w-24',
  lg: 'h-32 w-32',
  xl: 'h-48 w-48',
  full: 'w-full h-32',
};

const aspectRatioClasses = {
  square: 'aspect-square',
  video: 'aspect-video',
  auto: '',
};

export function AspectRatioImage({
  src,
  alt,
  className,
  containerClassName,
  aspectRatio = 'auto',
  size = 'full',
}: AspectRatioImageProps) {
  return (
    <div
      className={cn(
        'bg-gray-50 flex items-center justify-center overflow-hidden',
        sizeClasses[size],
        aspectRatioClasses[aspectRatio],
        containerClassName
      )}
    >
      <img
        src={src}
        alt={alt}
        className={cn('max-w-full max-h-full object-contain', className)}
      />
    </div>
  );
}

interface ProductThumbnailProps {
  src?: string | null;
  alt: string;
  size?: 'sm' | 'md';
  className?: string;
  fallback?: React.ReactNode;
}

export function ProductThumbnail({
  src,
  alt,
  size = 'sm',
  className,
  fallback,
}: ProductThumbnailProps) {
  const sizeClass = size === 'sm' ? 'w-16 h-16' : 'w-20 h-20';

  if (!src) {
    return (
      <div
        className={cn(
          'bg-muted rounded flex items-center justify-center flex-shrink-0',
          sizeClass,
          className
        )}
      >
        {fallback || (
          <svg
            className="h-6 w-6 text-muted-foreground"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
            />
          </svg>
        )}
      </div>
    );
  }

  return (
    <div
      className={cn(
        'bg-muted rounded overflow-hidden flex items-center justify-center flex-shrink-0',
        sizeClass,
        className
      )}
    >
      <img src={src} alt={alt} className="h-full w-full object-cover" />
    </div>
  );
}

